export default __webpack_public_path__ + "static/media/all.c33cde99.svg";